import * as types from './mutation-types'
import { service } from '@/api/Rest'
export const login = async ({ commit }, creds) => {
  commit(types.START_LOADER)
  try {
    let { data } = await service.login(creds);
    service.updateHeaders(data)
    commit(types.CURRENT_USER, data.user);
    commit(types.FINISH_LOADER)
    return true;
  } catch (error) {
    commit(types.ERROR_MESSAGE, {
      message: "Credenciales incorrectas intentelo de nuevo"
    })
    commit(types.FINISH_LOADER)
    return false;
  }
}
export const getCurrentUser = async ({ commit }) => {
  try {
    let { data } = await service.getCurrentUser()
    commit(types.CURRENT_USER, data)
    var actualB = {}
    for (var item of data.business) {
      if (data.cachedBusinessId == item.id) {
        actualB = item;
        break;
      }
    }
    commit(types.CURRENT_BUSINESSLIST, data.business)
    commit(types.CURRENT_BUSINESS, actualB)
    return data;
  } catch (error) {
    throw new Error('no user');
  }
}

export const selectBusiness = async (store, payload) => {
  let { data } = await service.cachedBusiness(payload);
  location.reload();
}
export const getModules = async ({ commit }, payload) => {
  let { data } = await service.getModules()
  commit(types.UPDATE_MODULES, data)
}

/**
 * AREAS 
 */
export const addNewArea = async ({ commit, state }, payload) => {
  let { data } = await service.addNewArea({
    businessId: state.businessId,
    type: (state.businessId) ? 'business' : 'personal',
    autorId: state.currentUser.id,
    ...payload
  })
  commit(types.ADDNEW_AREA, data)
}

export const addNewDatagroup = async ({ commit, state }, payload) => {
  let { data } = await service.addNewDatagroup({
    businessId: state.businessId,
    type: (state.businessId) ? 'business' : 'personal',
    autorId: state.currentUser.id,
    ...payload
  })
  commit(types.ADDNEW_DATAGROUP, data)
}


export const getAreas = async ({ commit, state }, payload) => {
  if (state.businessId) {
    var { data } = await service.areas({
      businessId: state.businessId,
      branchoffice: state.actualBranchId
    })
  } else {
    var { data } = await service.myAreas({
      autorId: state.currentUser.id
    })
  }
  commit(types.UPDATE_AREAS, data)
}

export const getDataGroups = async ({ commit, state }, payload) => {
  if (state.businessId) {
    var { data } = await service.dataGroups({
      businessId: state.businessId,
      branchoffice: state.actualBranchId
    })
  } else {
    var { data } = await service.myDataGroups({
      autorId: state.currentUser.id
    })
  }
  
  console.log(data,"DATA");

  commit(types.UPDATE_DATAGROUPS, data)
}



export const selectArea = async ({ commit, state }, payload) => {
  let { data } = await service.areaDetail({
    id: payload.id
  })
  commit(types.SELECT_AREA, data);
}
export const getBoardPipelinesAndCards = async ({ commit, state }, payload) => {
  let { data } = await service.board({
    id: payload.id
  })
  commit(types.SELECT_BOARD, data);
}
export const addCard = async ({ commit }, payload) => {
  let { data } = await service.addCard(payload);
  return data;
}
/**
 * PROXY-CARDS
 */
export const updateProxyCard = async ({ }, payload) => {
  let { data } = await service.updateProxyCard(payload);
  return data;
}
export const addProxyCardAttachment=async ({},payload)=>{
  let {data}  = await service.addProxyCardAttachment(payload)
  return data;
}


export const removeProxyCardAttachment=async ({},payload)=>{
  let {data}  = await service.removeProxyCardAttachment(payload)
  return data;
}

export const addCheckBox = async ({ }, payload) => {
  let { data } = await service.addCheckBox(payload);
  return data;
}

/**
 * CHECKBOX
 */
export const updateCheckBox = async ({ }, payload) => {
  let { data } = await service.updateCheckBox(payload);
  return data;
}
export const deleteCheckBox = async ({ }, payload) => {
  await service.deleteCheckBox(payload);
  return;
}

/**
 * FILE UPLOAD
 */
export const uploadFile = async ({ }, file) => {
  let { data } = await service.uploadFile(file);
  return data;
}
/**
 * BOARD
 */

 export const updateBoard=async({commit},payload)=>{
   let {data}=await service.updateBoard(payload);
   return data;
 }

 export const updateBoardColortags=async({commit},payload)=>{
  let {data}=await service.updateBoardColortags(payload);
  commit(types.UPDATE_COLORTAGS,data);
  return data;
 }

/** 
 * PROXY CARD
*/
export const selectPcard=async({commit},payload)=>{
  commit(types.SELECTPCARD,payload);
  return payload;
 }


/**
* CARDS
*/
export const updateCard = async ({ }, payload) => {
  let { data } = await service.updateCard(payload);
  return data;
}
export const addPipeline = async (ctx, payload) => {
  let { data } = await service.addBoardPipeline(payload);
  getBoardPipelinesAndCards(ctx, { id: payload.boardId })
}

export const getallBoards = async ({ commit }, payload) => {
  let { data } = await service.getallBoards(payload);
  commit(types.ALLBOARDS_BUSINESS, data);
}
export const getallPipelines = async ({ commit }, payload) => {
  let { data } = await service.getallPipelines(payload);
  commit(types.ALLPIPELINES_BUSINESS, data)
}

export const genShareLink=async({commit},payload)=>{
  let {data}=await service.genShareLink(payload);
  return data;
}

export const getSharelinkDetail=async({commit},payload)=>{
  let {data}=await service.getSharelinkDetail(payload);
  commit(types.UPDATE_SHARELINKDETAIL,data)
  return data;
}



export const updatePipeline = async ({ commit }, payload) => {
  let { data } = await service.updatePipeline(payload);
  return data;
}
export const addpipHook = async ({ commit }, payload) => {
  let { data } = await service.addpipHook(payload);
  return data;
}
export const updatepipHook = async ({ commit }, payload) => {
  let { data } = await service.updatepipHook(payload);
  return data;
}
//updatepipAction
export const addpipAction = async ({ commit }, payload) => {
  let { data } = await service.addpipAction(payload);
  return data;
}
export const updatepipAction = async ({ commit }, payload) => {
  let { data } = await service.updatepipAction(payload);
  return data;
}

export const addpipTarget = async ({ commit }, payload) => {
  let { data } = await service.addpipTarget(payload);
  return data;
}
export const updatepipTarget = async ({ commit }, payload) => {
  let { data } = await service.updatepipTarget(payload);
  return data;
}

export const deletepipHook = async ({ commit }, payload) => {
  await service.deletepipHook(payload)
}

export const proxyCardAddComment = async ({ commit }, payload) => {
  let { data } = await service.proxyCardAddComment(payload)
  return data;
}
export const proxyCardDetail = async ({ commit }, payload) => {
  let { data } = await service.proxyCardDetail(payload)
  return data;
}
/**
 * BOARD
 */
export const addBoard = async ({ commit }, payload) => {
  let { data } = await service.addBoard(payload)
  return data;
}

// export const attachPackpipeline=async({},payload)=>{
//   let {data}=await service.attachPackpipeline(payload);
//   return data;
// }


export const getSchema = async ({ commit }, payload) => {
  let { data } = await service.getSchema(payload)
  return data;
}

export const getSchemaList = async ({ state, commit }) => {
  let { data } = await service.getSchemaList({
    businessId: state.businessId
  })
  commit(types.UPDATE_SCHEMES, data);
  return data;
}

export const addPack = async ({ commit }, payload) => {
  let { data } = await service.addPack(payload)
  return data;
}

export const setSchema = async ({ commit }, payload) => {
  let { data } = await service.setSchema(payload)
  return data;
}
export const setActualScheme = async ({ commit }, payload) => {
  commit('UPDATE_ACTUALSCHEME', payload)
}

export const createPackcard = async ({ commit }, payload) => {
  let { data } = await service.createPackcard(payload)
  commit('UPDATE_ACTUALPACKDATA',data)
  return data;
}

export const updatePackcard = async ({ commit }, payload) => {
  let { data } = await service.updatePackcard(payload)
  return data;
}

export const genPackSource = async ({ commit, state }, payload) => {
  let { data } = await service.genPackSource({
    businessId: state.businessId,
    ...payload
  })
  return data;
}

export const getPackcards = async ({ commit, state }, payload) => {
  let { data } = await service.getPackdata({
    ...payload
  })
  return data;
}

export const getDecoyCards = async ({ commit, state }, payload) => {
  let { data } = await service.getDecoyCards({
    ...payload
  })
  return data;
}


export const getPackdata = async ({ commit, state }, payload) => {
  let { data } = await service.getPackdata({
    ...payload
  })
  commit(types.UPDATE_PACKDATA, data)
  return data;
}

export const getPacks = async ({ commit, state }) => {
  let { data } = await service.getPacks({
    businessId: state.businessId
  })
  commit(types.UPDATE_PACKLIST, data)
  return data;
}

export const addBoardTarget=async({commit},payload)=>{
  let { data } = await service.addBoardTarget(payload)
  commit(types.UPDATE_TARGETLIST, data)
  return data;
}




export const addTeamOrMember = async ({ commit }, payload) => {
  let { data } = await service.addTeamOrMember(payload)
  return data;
}

export const removeTeamOrMember = async ({ commit }, payload) => {
  let { data } = await service.removeTeamOrMember(payload)
  return data;
}
/**
 * TEAMS
 */
export const createTeam = async ({ commit, state }, payload) => {
  let { data } = await service.createTeam({
    autorId: state.currentUser.id,
    businessId: state.businessId,
    ...payload
  })
  commit(types.UPDATE_ACTUALTEAMS, data)
  return data;
}

export const getTeams = async ({ commit, state }, payload) => {
  if (!state.businessId) {
    var { data } = await service.getMyTeams({
      userId: state.currentUser.id
    })
  } else {
    var { data } = await service.getBusinessTeams({
      businessId: state.businessId
    })
  }
  commit(types.GET_TEAMS, data);
}

//BRANCHS

// export const actualBranch=async({commit,state},payload)=>{
//   commit(types.SET_ACTUALBRANCH,payload); 
// }
export const getBranchs = async ({ commit, state }, payload) => {
  if (state.businessId) {
    var { data } = await service.getBusinessBranchs({
      businessId: state.businessId
    })
    var selectedBranch = null;
    for (var item of data) {
      if (item.id == state.actualBranchId) {
        var selectedBranch = item;
        break;
      }
    }
    if (selectedBranch)
      commit(types.SET_ACTUALBRANCH, selectedBranch);
    commit(types.GET_BRANCHS, data);
  }
}
export const createBranch = async ({ commit, state }, payload) => {
  let { data } = await service.createBranch({
    autorId: state.currentUser.id,
    businessId: state.businessId,
    ...payload
  })
  commit(types.UPDATE_ACTUALBRANCHS, data)
  return data;
}

export const getTeamDetail = async ({ commit, state }, payload) => {
  let { data } = await service.getTeamDetail(payload)
  commit(types.SELECTED_TEAM, data);
}
export const addTeamMembers = async ({ commit, state }, payload) => {
  let { data } = await service.addTeamMembers(payload)
  commit(types.SELECTED_TEAM, data);
}

/**
 * findUser
 */
export const findUser = async ({ commit, state }, payload) => {
  let { data } = await service.findUser(payload)
  return data;
}
export const findTeam = async ({ commit, state }, payload) => {
  let { data } = await service.findTeam(payload)
  return data;
}

export const getNotifications = async ({ commit, state }, payload) => {
  let { data } = await service.getNotifications(payload)
  commit(types.SET_NOTIFICATIONS, data);
  return data;
}
/**
 * MEMBERS
 */
export const getBusinessMembers = async ({ commit, state }) => {
  let { data } = await service.getBusinessMembers({
    businessId: state.businessId
  })
  commit(types.BUSINESS_MEMBERS, data)
}

export const addBusinessMember = async ({ commit, state }, payload) => {
  let { data } = await service.addBusinessMember({
    businessId: state.businessId,
    ...payload
  })
  commit(types.ADDBUSINESS_MEMBERS, data)
}
export const addProxyCardMembers = async ({ commit, state }, payload) => {
  let { data } = await service.addProxyCardMembers(payload)
  return data;
}

export const deleteProxyCardMember = async ({ commit, state }, payload) => {
  let { data } = await service.deleteProxyCardMember(payload)
  return data;
}

/**
 * INTEGRACIONES
 */
export const getIntegrationsHub = async ({ commit }) => {
  var { data } = await service.integraionshub()
  commit(types.UPDATE_INTEGRATIONSHUB, data)
  return data;
}

export const linkPage = async ({ commit, state }, payload) => {
  if (state.businessId) {
    var { data } = await service.createIntegration({
      businessId: state.businessId,
      ...payload
    })
  } else {
    var { data } = await service.createMyIntegraions({
      ownerId: state.currentUser.id,
      ...payload
    })
  }
  commit(types.ADD_INTEGRATION, data);
  return data;
}

export const linkBoardIntegration = async ({ commit, state }, payload) => {
  var { data } = await service.linkBoardIntegration(payload)
  return data;
}

export const getIntegrations = async ({ commit, state }, payload) => {
  if (state.businessId) {
    var { data } = await service.integraions({
      businessId: state.businessId
    })
  } else {
    var { data } = await service.myIntegraions({
      ownerId: state.currentUser.id
    })
  }
  commit(types.UPDATE_INTEGRATIONS, data);
  return data;
}

export const getCardFrecuencies=async({commit},payload)=>{
  var {data}=await service.getCardFrecuencies(payload);
  return data;
}

//cambios
export const createFrecuency=async({commit},payload)=>{
  var {data}=await service.createFrecuency(payload);
  return data;
}
export const updateFrecuency=async({commit},payload)=>{
  var {data}=await service.updateFrecuency(payload);
  return data;
}
export const deleteFrecuency=async({commit},payload)=>{
  var {data}=await service.deleteFrecuency(payload);
  return data;
}

export const getColortags=async({commit},payload)=>{
  var {data}=await service.getColortags(payload);
  commit(types.SET_COLORTAGS,data);
}

export const getTargets=async({commit},payload)=>{
  var {data}=await service.getTargets(payload)
  commit(types.SET_TARGETLIST,data)
}

export const updateTarget=async({commit},payload)=>{
  var {data}=await service.updateTarget(payload)
  return data;
}



export const attachProxycardIntegrationData=async({commit},payload)=>{
  var {data}=await service.attachProxycardIntegrationData(payload)
  return data;
}

// FLUJO DE MODAL DEL APLICATIVO
export const openColumnModal=async({commit},payload)=>{
  commit(types.OPEN_COLUMNMODAL,payload);
  var {data}=await service.getFullPipeline(payload);
  commit(types.SET_ACTUALPIPELINE,data)
}

//PIPLOCK 
export const getPiplockinfo = async (store,payload)=>{
  var {data}=await service.getPiplockinfo(payload);
  return data;
}